import api from "./api";

// ============================
// Get All Header Items
// ============================
export const getHeader = async () => {
  const response = await api.get("/header");
  return response;
};

// ============================
// Get Header Tree
// Parent + Children
// ============================
export const getHeaderTree = async () => {
  const response = await api.get("/header/tree");
  return response;
};

// ============================
// Get Header By ID
// ============================
export const getHeaderById = async (id) => {
  const response = await api.get(`/header/${id}`);
  return response;
};

// ============================
// Create Header Item
// ============================
export const createHeader = async (data) => {
  const response = await api.post("/header", data);
  return response;
};

// ============================
// Update Header Item
// ============================
export const updateHeader = async (id, data) => {
  const response = await api.put(`/header/${id}`, data);
  return response;
};

// ============================
// Delete Header Item
// ============================
export const deleteHeader = async (id) => {
  const response = await api.delete(`/header/${id}`);
  return response;
};